import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import $t from '../../../i18n'
import Dialog from '../Dialog'
import cx from 'classnames'

import './Alert.css'

const Alert = ({
  title,
  className,
  closable = false,
  onCancel,
  onOk,
  shouldDisplay,
  actions,
  OkText = $t('common.ok'),
  children
}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(shouldDisplay)
  }, [shouldDisplay])

  const handleOk = () => {
    if (onOk) {
      onOk()
    }

    setIsVisible(false)
  }

  const handleCancel = () => {
    if (onCancel) {
      onCancel()
    }

    setIsVisible(false)
  }

  const dialogActions = actions || [
    <Button key='1' className='dialog-action' type='primary' onClick={handleOk}>
      {OkText}
    </Button>
  ]

  return (
    <Dialog
      title={title}
      isVisible={isVisible}
      footerActions={dialogActions}
      onCancel={handleCancel}
      closable={closable}
      className={cx('alert-dialog', className)}
    >
      {!!children && children}
    </Dialog>
  )
}

export default Alert
